import { render, staticRenderFns } from "./preview-edit-module.vue?vue&type=template&id=ed2f6bea"
import script from "./preview-edit-module.vue?vue&type=script&lang=js"
export * from "./preview-edit-module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports